(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dh-blog-gallery"] && !Shopify.designMode) return;
  try {
    
  // Static JS: initializes any slider with [data-slider]
  (function () {
    function initSlider(root) {
      if (!root || root.dataset.inited === 'true') return;
      root.dataset.inited = 'true';

      var track = root.querySelector('[data-track]');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var dotsC = root.querySelector('[data-dots]');
      if (!track) return;

      var originalSlides = Array.prototype.slice.call(track.querySelectorAll('.image-slider__slide'));
      var slideCount = originalSlides.length;
      if (!slideCount) {
        try {
          console.warn('DH Horizontal Gallery: no slides detected to render.', root);
        } catch (err) {
          /* no-op */
        }
        return;
      }

      originalSlides.forEach(function (slide, index) {
        slide.dataset.originalIndex = index;
        slide.dataset.loopClone = 'false';
        var imgs = slide.querySelectorAll('img');
        for (var imgIdx = 0; imgIdx < imgs.length; imgIdx++) {
          imgs[imgIdx].setAttribute('draggable', 'false');
        }
      });

      var loopState = setupFiniteLoop();
      var snapTimeout = 0;
      var SNAP_DELAY = 160;
      var isLoopJump = false;
      var isDragging = false;
      var isPointerDown = false;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragStartScroll = 0;
      var hasLockedAxis = false;
      var userOverride = true; // block snapping/adjustments until ready
      var shouldSnap = false; // enable after initial position
      var commandedIndex = 0;
      var sliderReady = false;
      var firstRealSlide = null;

      if (root && root.dataset) root.dataset.slideCount = slideCount;

      refreshLoopMetrics(loopState, 'initial-init');
      firstRealSlide = loopState.realSlides[0] || null;
      commandedIndex = 0;
      prepareInitialPosition();
      onUpdate();

      function markSliderReady() {
        if (sliderReady || !root) return;
        sliderReady = true;
        root.classList.add('is-ready');
      }

      function prepareInitialPosition() {
        if (!firstRealSlide) {
          markSliderReady();
          return;
        }
        var firstSlideImage = firstRealSlide.querySelector('img');
        var finalize = function () {
          if (sliderReady) return;
          refreshLoopMetrics(loopState, 'initial-position');
          var prevBehavior = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = 0;
          track.style.scrollBehavior = prevBehavior || '';
          shouldSnap = true;
          userOverride = false;
          markSliderReady();
          onUpdate();
        };
        if (firstSlideImage && !firstSlideImage.complete) {
          firstSlideImage.addEventListener('load', finalize, { once: true });
        } else {
          finalize();
        }
      }

      function onMediaLoad() {
        refreshLoopMetrics(loopState, 'media-load');
        if (userOverride) return;
        onUpdate();
      }

      originalSlides.forEach(function (slide) {
        var imgs = slide.querySelectorAll('img');
        for (var imgIdx = 0; imgIdx < imgs.length; imgIdx++) {
          if (imgs[imgIdx].complete) {
            onMediaLoad();
          } else {
            imgs[imgIdx].addEventListener('load', onMediaLoad);
          }
        }
      });

      function getClientX(ev) {
        if (ev.touches && ev.touches.length) {
          return ev.touches[0].clientX;
        }
        return ev.clientX;
      }

      function getClientY(ev) {
        if (ev.touches && ev.touches.length) {
          return ev.touches[0].clientY;
        }
        return ev.clientY;
      }

      function startDrag(ev) {
        if (ev.type === 'mousedown' && ev.button !== 0) return;
        if (isDragging || isPointerDown) return;
        userOverride = true;
        shouldSnap = false;
        isPointerDown = true;
        dragStartX = getClientX(ev);
        dragStartY = getClientY(ev);
        dragStartScroll = track.scrollLeft;
        hasLockedAxis = false;
        if (ev.type === 'mousedown') {
          isDragging = true;
          track.classList.add('is-dragging');
          ev.preventDefault();
        }
        document.addEventListener('mousemove', moveDrag);
        document.addEventListener('mouseup', stopDrag);
        document.addEventListener('touchmove', moveDrag, { passive: false });
        document.addEventListener('touchend', stopDrag);
        document.addEventListener('touchcancel', stopDrag);
      }

      function moveDrag(ev) {
        if (!isDragging && !isPointerDown) return;
        var currentX = getClientX(ev);
        var currentY = getClientY(ev);
        var delta = currentX - dragStartX;
        var deltaY = currentY - dragStartY;
        if (ev.touches && !hasLockedAxis) {
          if (Math.abs(deltaY) > Math.abs(delta) && Math.abs(deltaY) > 6) {
            isPointerDown = false;
            isDragging = false;
            track.classList.remove('is-dragging');
            return;
          }
          if (Math.abs(delta) > 6) {
            hasLockedAxis = true;
            isDragging = true;
            track.classList.add('is-dragging');
          }
        }
        if (!isDragging) return;
        track.scrollLeft = dragStartScroll - delta;
        if (ev.type === 'mousemove' || (ev.touches && ev.cancelable && hasLockedAxis)) {
          ev.preventDefault();
        }
      }

      function stopDrag() {
        if (!isDragging && !isPointerDown) return;
        isPointerDown = false;
        isDragging = false;
        track.classList.remove('is-dragging');
        document.removeEventListener('mousemove', moveDrag);
        document.removeEventListener('mouseup', stopDrag);
        document.removeEventListener('touchmove', moveDrag);
        document.removeEventListener('touchend', stopDrag);
        document.removeEventListener('touchcancel', stopDrag);
        userOverride = false;
      }

      track.addEventListener('mousedown', startDrag);
      track.addEventListener('touchstart', startDrag);
      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      track.addEventListener(
        'wheel',
        function () {
          userOverride = true;
          shouldSnap = false;
        },
        { passive: true }
      );

      function scheduleSnapToClosest(delay) {
        if (slideCount <= 1 || userOverride || !shouldSnap) return;
        if (snapTimeout) window.clearTimeout(snapTimeout);
        var snapDelay = typeof delay === 'number' ? delay : SNAP_DELAY;
        snapTimeout = window.setTimeout(function () {
          if (isDragging) {
            scheduleSnapToClosest(SNAP_DELAY);
            return;
          }
          var activeInfo = getActiveSlideInfo();
          if (activeInfo.slide) {
            centerOnSlide(activeInfo.slide, 'smooth');
          }
        }, snapDelay);
      }

      function updateDots(activeIndex) {
        if (!dotsC) return;
        if (!dotsC.children.length) {
          for (var i = 0; i < slideCount; i++) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'image-slider__dot';
            d.setAttribute('role', 'tab');
            d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            (function (index) {
              d.addEventListener('click', function () {
                shouldSnap = true;
                userOverride = false;
                scrollToIndex(index, 0);
              });
            })(i);
            dotsC.appendChild(d);
          }
        }
        var dots = dotsC.querySelectorAll('.image-slider__dot');
        for (var j = 0; j < dots.length; j++) {
          dots[j].setAttribute('aria-current', j === activeIndex ? 'true' : 'false');
        }
      }

      function getActiveSlideInfo() {
        var slideNodes = track.querySelectorAll('.image-slider__slide');
        if (!slideNodes.length) {
          return { slide: null, index: 0 };
        }
        var maxScroll = track.scrollWidth - track.clientWidth;
        var scrollLeft = track.scrollLeft;
        var edgeTolerance = 2;
        if (scrollLeft <= edgeTolerance) {
          var first = slideNodes[0];
          var firstIndex = first ? parseInt(first.dataset.originalIndex || '0', 10) : 0;
          if (isNaN(firstIndex)) firstIndex = 0;
          return { slide: first, index: firstIndex };
        }
        if (scrollLeft >= maxScroll - edgeTolerance) {
          var last = slideNodes[slideNodes.length - 1];
          var lastIndex = last ? parseInt(last.dataset.originalIndex || '0', 10) : slideNodes.length - 1;
          if (isNaN(lastIndex)) lastIndex = slideNodes.length - 1;
          return { slide: last, index: lastIndex };
        }
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var bestSlide = null;
        var bestDistance = Infinity;
        for (var i = 0; i < slideNodes.length; i++) {
          var rect = slideNodes[i].getBoundingClientRect();
          var center = rect.left + rect.width / 2;
          var distance = Math.abs(center - trackCenter);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestSlide = slideNodes[i];
          }
        }
        var index = bestSlide ? parseInt(bestSlide.dataset.originalIndex || '0', 10) : 0;
        if (isNaN(index)) index = 0;
        return { slide: bestSlide, index: index };
      }

      function chooseCandidate(candidates, direction) {
        if (!candidates.length) return null;
        var trackRect = track.getBoundingClientRect();
        var trackCenter = track.scrollLeft + trackRect.width / 2;
        var fallback = candidates[0];
        var best = null;
        var bestDistance = Infinity;
        var dir = typeof direction === 'number' ? direction : 0;

        for (var i = 0; i < candidates.length; i++) {
          var rect = candidates[i].getBoundingClientRect();
          var center = candidates[i].offsetLeft + rect.width / 2;
          var delta = center - trackCenter;
          var distance = Math.abs(delta);
          if (dir > 0 && delta < -1) {
            continue;
          }
          if (dir < 0 && delta > 1) {
            continue;
          }
          if (distance < bestDistance) {
            bestDistance = distance;
            best = candidates[i];
          }
        }

        if (!best) {
          bestDistance = Infinity;
          for (var j = 0; j < candidates.length; j++) {
            var rectAlt = candidates[j].getBoundingClientRect();
            var centerAlt = rectAlt.left + rectAlt.width / 2;
            var distanceAlt = Math.abs(centerAlt - trackCenter);
            if (distanceAlt < bestDistance) {
              bestDistance = distanceAlt;
              best = candidates[j];
            }
          }
        }

        return best || fallback;
      }

      function getRealSlideByIndex(index) {
        if (!loopState || !loopState.realSlides || !loopState.realSlides.length) return null;
        if (index < 0 || index >= loopState.realSlides.length) return null;
        return loopState.realSlides[index] || null;
      }

      function scrollToIndex(targetIndex, direction, behavior, options) {
        if (!slideCount) return;
        var opts = options || {};
        var clamped = targetIndex;
        if (clamped < 0) clamped = 0;
        if (clamped > slideCount - 1) clamped = slideCount - 1;
        var baseSelector = '.image-slider__slide[data-original-index="' + clamped + '"]';
        var selector = baseSelector;
        var candidates;

        if (opts.forceExact) {
          var exactSlide = getRealSlideByIndex(clamped);
          if (exactSlide) {
            candidates = [exactSlide];
          }
        }

        if (!candidates) {
          if (opts.forceReal || opts.forceExact) {
            selector = baseSelector + '[data-loop-clone="false"]';
            candidates = track.querySelectorAll(selector);
            if (!candidates.length) {
              candidates = track.querySelectorAll(baseSelector);
            }
          } else {
            candidates = track.querySelectorAll(baseSelector);
          }
        }
        var candidateCloneFlags = [];
        if (candidates && typeof candidates.length === 'number') {
          for (var cIdx = 0; cIdx < candidates.length; cIdx++) {
            var cSlide = candidates[cIdx];
            candidateCloneFlags.push(cSlide && cSlide.dataset ? cSlide.dataset.loopClone : 'unknown');
          }
        }
        var slide = chooseCandidate(candidates, direction);
        if (slide) {
          commandedIndex = clamped;
          if (!opts.preserveOverride) {
            userOverride = false;
          }
          centerOnSlide(slide, behavior);
        } else {
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          var active = getActiveSlideInfo();
          shouldSnap = true;
          userOverride = false;
          scrollToIndex(active.index - 1, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          var active = getActiveSlideInfo();
          shouldSnap = true;
          userOverride = false;
          scrollToIndex(active.index + 1, 1);
        });
      }

      function centerOnSlide(slide, behavior) {
        if (!slide) return;
        if (snapTimeout) window.clearTimeout(snapTimeout);
        var slideOffset = slide.offsetLeft;
        var slideWidth = slide.offsetWidth || slide.getBoundingClientRect().width;
        var target = slideOffset - (track.clientWidth - slideWidth) / 2;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (target < 0) target = 0;
        if (target > maxScroll) target = maxScroll;
        var scrollBehavior = behavior || 'smooth';
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: target, behavior: scrollBehavior });
        } else {
          track.scrollLeft = target;
        }
      }

      function refreshLoopMetrics(state, reason) {
        if (!state) return;
        state.realSlides = Array.prototype.slice.call(
          track.querySelectorAll('.image-slider__slide[data-loop-clone="false"]')
        );
        var firstReal = state.realSlides[0];
        var lastReal = state.realSlides[state.realSlides.length - 1];
        state.loopStart = firstReal ? firstReal.offsetLeft : 0;
        state.loopEnd = lastReal ? lastReal.offsetLeft + lastReal.offsetWidth : state.loopStart;
        state.loopWidth = state.loopEnd - state.loopStart;
      }

      function setupFiniteLoop() {
        var state = {
          realSlides: originalSlides.slice(),
          loopStart: 0,
          loopEnd: 0,
          loopWidth: 0,
        };
        refreshLoopMetrics(state, 'setup');
        return state;
      }

      function handleLoopBounds() {
        return false;
      }

      function onUpdate() {
        if (handleLoopBounds()) return;
        var activeInfo = getActiveSlideInfo();
        updateDots(activeInfo.index);
        updateArrows(activeInfo.index);
      }

      function updateArrows(activeIndex) {
        if (!prev && !next) return;
        var atStart = activeIndex <= 0;
        var atEnd = activeIndex >= slideCount - 1;
        if (prev) {
          prev.disabled = atStart;
          prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        }
        if (next) {
          next.disabled = atEnd;
          next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
      }

      var handleResize = function () {
        refreshLoopMetrics(loopState, 'resize');
        if (!userOverride) {
          scrollToIndex(commandedIndex, 0, 'auto', {
            preserveOverride: true,
            forceReal: true,
            forceExact: true,
          });
        }
        onUpdate();
      };

      track.addEventListener(
        'scroll',
        function () {
          window.requestAnimationFrame(onUpdate);
          scheduleSnapToClosest();
        },
        { passive: true }
      );
      window.addEventListener('resize', handleResize);
      onUpdate();
    }

    function initAll() {
      document.querySelectorAll('[data-slider] .js-image-slider').forEach(function (el) {
        initSlider(el.closest('[data-slider]'));
      });
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('DOMContentLoaded', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dh-custom-gallery"] && !Shopify.designMode) return;
  try {
    
  // Static JS: initializes any slider with [data-slider]
  (function () {
    function initSlider(root) {
      if (!root || root.dataset.inited === 'true') return;
      root.dataset.inited = 'true';

      var track = root.querySelector('[data-track]');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var dotsC = root.querySelector('[data-dots]');
      if (!track) return;

      var originalSlides = Array.prototype.slice.call(track.querySelectorAll('.image-slider__slide'));
      var slideCount = originalSlides.length;
      if (!slideCount) {
        try {
          console.warn('DH Horizontal Gallery: no slides detected to render.', root);
        } catch (err) {
          /* no-op */
        }
        return;
      }

      originalSlides.forEach(function (slide, index) {
        slide.dataset.originalIndex = index;
        slide.dataset.loopClone = 'false';
        var imgs = slide.querySelectorAll('img');
        for (var imgIdx = 0; imgIdx < imgs.length; imgIdx++) {
          imgs[imgIdx].setAttribute('draggable', 'false');
        }
      });

      var loopState = setupFiniteLoop();
      var snapTimeout = 0;
      var SNAP_DELAY = 160;
      var isLoopJump = false;
      var isDragging = false;
      var isPointerDown = false;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragStartScroll = 0;
      var hasLockedAxis = false;
      var allowLoopAdjustments = false;
      var userOverride = true; // prevent snap/loop during init
      var shouldSnap = false; // enable after initial position
      var commandedIndex = 0;
      var sliderReady = false;
      var firstRealSlide = null;

      if (root && root.dataset) root.dataset.slideCount = slideCount;

      refreshLoopMetrics(loopState);
      firstRealSlide = loopState.realSlides[0] || null;
      commandedIndex = 0;
      prepareInitialPosition();
      onUpdate();

      function markSliderReady() {
        if (sliderReady || !root) return;
        sliderReady = true;
        root.classList.add('is-ready');
      }

      function prepareInitialPosition() {
        if (!firstRealSlide) {
          markSliderReady();
          return;
        }
        var firstSlideImage = firstRealSlide.querySelector('img');
        var finalize = function () {
          if (sliderReady) return;
          refreshLoopMetrics(loopState);
          var prevBehavior = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = 0;
          track.style.scrollBehavior = prevBehavior || '';
          shouldSnap = true;
          userOverride = false;
          markSliderReady();
          onUpdate();
        };
        if (firstSlideImage && !firstSlideImage.complete) {
          firstSlideImage.addEventListener('load', finalize, { once: true });
        } else {
          finalize();
        }
      }

      function onMediaLoad() {
        refreshLoopMetrics(loopState);
        if (userOverride) return;
        onUpdate();
      }

      originalSlides.forEach(function (slide) {
        var imgs = slide.querySelectorAll('img');
        for (var imgIdx = 0; imgIdx < imgs.length; imgIdx++) {
          if (imgs[imgIdx].complete) {
            onMediaLoad();
          } else {
            imgs[imgIdx].addEventListener('load', onMediaLoad);
          }
        }
      });

      function getClientX(ev) {
        if (ev.touches && ev.touches.length) {
          return ev.touches[0].clientX;
        }
        return ev.clientX;
      }

      function getClientY(ev) {
        if (ev.touches && ev.touches.length) {
          return ev.touches[0].clientY;
        }
        return ev.clientY;
      }

      function startDrag(ev) {
        if (ev.type === 'mousedown' && ev.button !== 0) return;
        if (isDragging || isPointerDown) return;
        userOverride = true;
        shouldSnap = false;
        isPointerDown = true;
        dragStartX = getClientX(ev);
        dragStartY = getClientY(ev);
        dragStartScroll = track.scrollLeft;
        hasLockedAxis = false;
        if (ev.type === 'mousedown') {
          isDragging = true;
          track.classList.add('is-dragging');
          ev.preventDefault();
        }
        document.addEventListener('mousemove', moveDrag);
        document.addEventListener('mouseup', stopDrag);
        document.addEventListener('touchmove', moveDrag, { passive: false });
        document.addEventListener('touchend', stopDrag);
        document.addEventListener('touchcancel', stopDrag);
      }

      function moveDrag(ev) {
        if (!isDragging && !isPointerDown) return;
        var currentX = getClientX(ev);
        var currentY = getClientY(ev);
        var delta = currentX - dragStartX;
        var deltaY = currentY - dragStartY;
        if (ev.touches && !hasLockedAxis) {
          if (Math.abs(deltaY) > Math.abs(delta) && Math.abs(deltaY) > 6) {
            isPointerDown = false;
            isDragging = false;
            track.classList.remove('is-dragging');
            return;
          }
          if (Math.abs(delta) > 6) {
            hasLockedAxis = true;
            isDragging = true;
            track.classList.add('is-dragging');
          }
        }
        if (!isDragging) return;
        track.scrollLeft = dragStartScroll - delta;
        if (ev.type === 'mousemove' || (ev.touches && ev.cancelable && hasLockedAxis)) {
          ev.preventDefault();
        }
      }

      function stopDrag() {
        if (!isDragging && !isPointerDown) return;
        isPointerDown = false;
        isDragging = false;
        track.classList.remove('is-dragging');
        document.removeEventListener('mousemove', moveDrag);
        document.removeEventListener('mouseup', stopDrag);
        document.removeEventListener('touchmove', moveDrag);
        document.removeEventListener('touchend', stopDrag);
        document.removeEventListener('touchcancel', stopDrag);
        userOverride = false;
        allowLoopAdjustments = true;
      }

      track.addEventListener('mousedown', startDrag);
      track.addEventListener('touchstart', startDrag);
      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      track.addEventListener(
        'wheel',
        function () {
          userOverride = true;
          shouldSnap = false;
        },
        { passive: true }
      );

      function scheduleSnapToClosest(delay) {
        if (slideCount <= 1 || userOverride || !shouldSnap) return;
        if (snapTimeout) window.clearTimeout(snapTimeout);
        var snapDelay = typeof delay === 'number' ? delay : SNAP_DELAY;
        snapTimeout = window.setTimeout(function () {
          if (isDragging) {
            scheduleSnapToClosest(SNAP_DELAY);
            return;
          }
          var activeInfo = getActiveSlideInfo();
          if (activeInfo.slide) {
            centerOnSlide(activeInfo.slide, 'smooth');
          }
        }, snapDelay);
      }

      function updateDots(activeIndex) {
        if (!dotsC) return;
        if (!dotsC.children.length) {
          for (var i = 0; i < slideCount; i++) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'image-slider__dot';
            d.setAttribute('role', 'tab');
            d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            (function (index) {
              d.addEventListener('click', function () {
                scrollToIndex(index, 0);
              });
            })(i);
            dotsC.appendChild(d);
          }
        }
        var dots = dotsC.querySelectorAll('.image-slider__dot');
        for (var j = 0; j < dots.length; j++) {
          dots[j].setAttribute('aria-current', j === activeIndex ? 'true' : 'false');
        }
      }

      function getActiveSlideInfo() {
        var slideNodes = track.querySelectorAll('.image-slider__slide');
        if (!slideNodes.length) {
          return { slide: null, index: 0 };
        }
        var maxScroll = track.scrollWidth - track.clientWidth;
        var scrollLeft = track.scrollLeft;
        var edgeTolerance = 2;
        if (scrollLeft <= edgeTolerance) {
          var first = slideNodes[0];
          var firstIndex = first ? parseInt(first.dataset.originalIndex || '0', 10) : 0;
          if (isNaN(firstIndex)) firstIndex = 0;
          return { slide: first, index: firstIndex };
        }
        if (scrollLeft >= maxScroll - edgeTolerance) {
          var last = slideNodes[slideNodes.length - 1];
          var lastIndex = last ? parseInt(last.dataset.originalIndex || '0', 10) : slideNodes.length - 1;
          if (isNaN(lastIndex)) lastIndex = slideNodes.length - 1;
          return { slide: last, index: lastIndex };
        }
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var bestSlide = null;
        var bestDistance = Infinity;
        for (var i = 0; i < slideNodes.length; i++) {
          var rect = slideNodes[i].getBoundingClientRect();
          var center = rect.left + rect.width / 2;
          var distance = Math.abs(center - trackCenter);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestSlide = slideNodes[i];
          }
        }
        var index = bestSlide ? parseInt(bestSlide.dataset.originalIndex || '0', 10) : 0;
        if (isNaN(index)) index = 0;
        return { slide: bestSlide, index: index };
      }

      function chooseCandidate(candidates, direction) {
        if (!candidates.length) return null;
        var trackRect = track.getBoundingClientRect();
        var trackCenter = track.scrollLeft + trackRect.width / 2;
        var fallback = candidates[0];
        var best = null;
        var bestDistance = Infinity;
        var dir = typeof direction === 'number' ? direction : 0;

        for (var i = 0; i < candidates.length; i++) {
          var rect = candidates[i].getBoundingClientRect();
          var center = candidates[i].offsetLeft + rect.width / 2;
          var delta = center - trackCenter;
          var distance = Math.abs(delta);
          if (dir > 0 && delta < -1) {
            continue;
          }
          if (dir < 0 && delta > 1) {
            continue;
          }
          if (distance < bestDistance) {
            bestDistance = distance;
            best = candidates[i];
          }
        }

        if (!best) {
          bestDistance = Infinity;
          for (var j = 0; j < candidates.length; j++) {
            var rectAlt = candidates[j].getBoundingClientRect();
            var centerAlt = rectAlt.left + rectAlt.width / 2;
            var distanceAlt = Math.abs(centerAlt - trackCenter);
            if (distanceAlt < bestDistance) {
              bestDistance = distanceAlt;
              best = candidates[j];
            }
          }
        }

        return best || fallback;
      }

      function getRealSlideByIndex(index) {
        if (!loopState || !loopState.realSlides || !loopState.realSlides.length) return null;
        if (index < 0 || index >= loopState.realSlides.length) return null;
        return loopState.realSlides[index] || null;
      }

      function scrollToIndex(targetIndex, direction, behavior, options) {
        if (!slideCount) return;
        var opts = options || {};
        var clamped = targetIndex;
        if (clamped < 0) clamped = 0;
        if (clamped > slideCount - 1) clamped = slideCount - 1;
        var baseSelector = '.image-slider__slide[data-original-index="' + clamped + '"]';
        var selector = baseSelector;
        var candidates;

        if (opts.forceExact) {
          var exactSlide = getRealSlideByIndex(clamped);
          if (exactSlide) {
            candidates = [exactSlide];
          }
        }

        if (!candidates) {
          if (opts.forceReal || opts.forceExact) {
            selector = baseSelector + '[data-loop-clone="false"]';
            candidates = track.querySelectorAll(selector);
            if (!candidates.length) {
              candidates = track.querySelectorAll(baseSelector);
            }
          } else {
            candidates = track.querySelectorAll(baseSelector);
          }
        }
        var slide = chooseCandidate(candidates, direction);
        if (slide) {
          commandedIndex = clamped;
          if (!opts.preserveOverride) {
            userOverride = false;
          }
          centerOnSlide(slide, behavior);
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          var active = getActiveSlideInfo();
          shouldSnap = true;
          userOverride = false;
          scrollToIndex(active.index - 1, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          var active = getActiveSlideInfo();
          shouldSnap = true;
          userOverride = false;
          scrollToIndex(active.index + 1, 1);
        });
      }

      function centerOnSlide(slide, behavior) {
        if (!slide) return;
        if (snapTimeout) window.clearTimeout(snapTimeout);
        var slideOffset = slide.offsetLeft;
        var slideWidth = slide.offsetWidth || slide.getBoundingClientRect().width;
        var target = slideOffset - (track.clientWidth - slideWidth) / 2;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (target < 0) target = 0;
        if (target > maxScroll) target = maxScroll;
        var scrollBehavior = behavior || 'smooth';
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: target, behavior: scrollBehavior });
        } else {
          track.scrollLeft = target;
        }
      }

      function refreshLoopMetrics(state) {
        if (!state) return;
        state.realSlides = Array.prototype.slice.call(
          track.querySelectorAll('.image-slider__slide[data-loop-clone="false"]')
        );
        var firstReal = state.realSlides[0];
        var lastReal = state.realSlides[state.realSlides.length - 1];
        state.loopStart = firstReal ? firstReal.offsetLeft : 0;
        state.loopEnd = lastReal ? lastReal.offsetLeft + lastReal.offsetWidth : state.loopStart;
        state.loopWidth = state.loopEnd - state.loopStart;
      }

      function setupFiniteLoop() {
        var state = {
          realSlides: originalSlides.slice(),
          loopStart: 0,
          loopEnd: 0,
          loopWidth: 0,
        };
        refreshLoopMetrics(state);
        return state;
      }

      function handleLoopBounds() {
        return false;
      }

      function onUpdate() {
        if (handleLoopBounds()) return;
        var activeInfo = getActiveSlideInfo();
        updateDots(activeInfo.index);
        updateArrows(activeInfo.index);
      }

      function updateArrows(activeIndex) {
        if (!prev && !next) return;
        var atStart = activeIndex <= 0;
        var atEnd = activeIndex >= slideCount - 1;
        if (prev) {
          prev.disabled = atStart;
          prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        }
        if (next) {
          next.disabled = atEnd;
          next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        }
      }

      var handleResize = function () {
        refreshLoopMetrics(loopState);
        if (!userOverride) {
          scrollToIndex(commandedIndex, 0, 'auto', {
            preserveOverride: true,
            forceReal: true,
            forceExact: true,
          });
        }
        onUpdate();
      };

      track.addEventListener(
        'scroll',
        function () {
          window.requestAnimationFrame(onUpdate);
          scheduleSnapToClosest();
        },
        { passive: true }
      );
      window.addEventListener('resize', handleResize);
      onUpdate();
    }

    function initAll() {
      document.querySelectorAll('[data-slider] .js-image-slider').forEach(function (el) {
        initSlider(el.closest('[data-slider]'));
      });
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('DOMContentLoaded', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dh-footer"] && !Shopify.designMode) return;
  try {
    

// --- IDENTIFY SECTION ID, THEN FIND FIRST BLOCK HEADER INSTANCE AND APPLY CSS CLASS --- //

(() => {
  function mark(sectionEl) {
    if (!sectionEl) return;
    // clear stale marks (editor re-renders)
    sectionEl.querySelectorAll('button.dh-footer__block-heading--button.is-first')
      .forEach(el => el.classList.remove('is-first'));

    const firstBtn = sectionEl.querySelector('button.dh-footer__block-heading--button');
    if (firstBtn) firstBtn.classList.add('is-first');
  }

  function markAll() {
    document.querySelectorAll('.dh-footer__main--container').forEach(container => {
      const sectionEl = container.closest('[id^="shopify-section-"]') || container;
      mark(sectionEl);
    });
  }

  // Storefront load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markAll);
  } else {
    markAll();
  }

  // Theme Editor hooks
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
  document.addEventListener('shopify:block:select', (e) => {
    if (e.target && e.target.querySelector('.dh-footer__main--container')) mark(e.target);
  });
})();


// --- DYNAMIC COLLAPSABLE CONTENT BEHAVIOUR --- //

// Initialise one footer section
function initFooterSection(root) {
  const blocks = root.querySelectorAll('.dh-footer__block-heading--container');
  if (!blocks.length) return;

  blocks.forEach(block => {
    const button  = block.querySelector('.dh-footer__block-heading--button');
    const arrow   = block.querySelector('.dh-footer__block-heading--arrow');
    const target  = button?.dataset.targetId;
    const content = target && root.querySelector('#' + target);

    if (!button || !content || !arrow) return;

    // Guard against duplicate listeners on theme editor refreshes
    if (button.dataset.dhInit === 'true') return;
    button.dataset.dhInit = 'true';

    button.addEventListener('click', () => {
      const isCurrentlyOpen = content.classList.contains('open');

      // Close any other block that is open in this section
      root.querySelectorAll('.dh-footer__block-content--collapsable.open').forEach(el => {
        if (el !== content) {
          el.classList.remove('open');
          const parentBlock   = el.closest('.dh-footer__block-heading--container');
          const parentButton  = parentBlock?.querySelector('.dh-footer__block-heading--button');
          const parentArrow   = parentBlock?.querySelector('.dh-footer__block-heading--arrow');
          parentArrow?.classList.remove('rotate');
          parentButton?.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle the clicked block
      const isOpenNow = content.classList.toggle('open', !isCurrentlyOpen);
      arrow.classList.toggle('rotate', isOpenNow);
      button.setAttribute('aria-expanded', String(isOpenNow));
    });
  });
}

// First load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-id]').forEach(initFooterSection);
});

// Theme editor AJAX reload
document.addEventListener('shopify:section:load', event => {
  const wrapper = event.target.querySelector('[data-section-id]');
  if (wrapper) initFooterSection(wrapper);
});


  } catch(e) { console.error(e); }
})();
})();
